var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "contents" },
    [
      _c(
        "div",
        { staticClass: "opt" },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "permissson",
                  rawName: "v-permissson",
                  value: "add",
                  expression: "'add'",
                },
              ],
              staticClass: "add flex_c_c",
              on: { click: _vm.add },
            },
            [
              _c("svg-icon", {
                directives: [
                  {
                    name: "permissson",
                    rawName: "v-permissson",
                    value: "add",
                    expression: "'add'",
                  },
                ],
                attrs: { className: "icon", iconClass: "add" },
              }),
              _vm._v(" 新增 "),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "permissson",
                  rawName: "v-permissson",
                  value: "export",
                  expression: "'export'",
                },
              ],
              staticClass: "add flex_c_c",
              staticStyle: { "margin-left": "10px", "margin-right": "10px" },
              on: { click: _vm.downloadFile },
            },
            [
              _c("svg-icon", {
                directives: [
                  {
                    name: "permissson",
                    rawName: "v-permissson",
                    value: "export",
                    expression: "'export'",
                  },
                ],
                attrs: { className: "icon", iconClass: "download" },
              }),
              _vm._v(" 导出 "),
            ],
            1
          ),
          _c(
            "BaseFilter",
            {
              attrs: { isActive: _vm.isActive, width: 516 },
              on: { sendFilter: _vm.sendFilter, reset: _vm.reset },
            },
            [
              _c(
                "div",
                { staticClass: "filter" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "form",
                      attrs: { model: _vm.filterList, "label-width": "116px" },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "中文品名" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "320px" },
                            attrs: { placeholder: "请输入中文品名" },
                            model: {
                              value: _vm.filterList.nameCH,
                              callback: function ($$v) {
                                _vm.$set(_vm.filterList, "nameCH", $$v)
                              },
                              expression: "filterList.nameCH",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "英文品名" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "320px" },
                            attrs: { placeholder: "请输入英文品名" },
                            model: {
                              value: _vm.filterList.nameEN,
                              callback: function ($$v) {
                                _vm.$set(_vm.filterList, "nameEN", $$v)
                              },
                              expression: "filterList.nameEN",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "税号" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "320px" },
                            attrs: { placeholder: "请输入税号" },
                            model: {
                              value: _vm.filterList.hsCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.filterList, "hsCode", $$v)
                              },
                              expression: "filterList.hsCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "data" },
        [
          _vm.height !== 0
            ? _c("BaseTable", {
                attrs: {
                  height: _vm.height,
                  tableData: _vm.tableData,
                  pageIndex: _vm.pager.pageIndex,
                  pageSize: _vm.pager.pageSize,
                  loading: _vm.loading,
                  isPager: true,
                  isEmptyBorder: true,
                },
                on: { handlePageChange: _vm.handlePageChange },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "fileQty",
                      fn: function (row) {
                        return [
                          _c("div", { staticClass: "fileQty" }, [
                            row.scope.fileQty > 0
                              ? _c("span", [
                                  _vm._v(" " + _vm._s(row.scope.fileQty) + " "),
                                  _c("i", {
                                    staticClass: "el-icon-folder-opened",
                                    staticStyle: {
                                      "margin-left": "5px",
                                      color: "#1258bc",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.link(row.scope)
                                      },
                                    },
                                  }),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "addRate1",
                      fn: function (row) {
                        return [
                          _c("p", [
                            _c(
                              "span",
                              {
                                staticClass: "pickUpType",
                                class: `pickUpType0`,
                              },
                              [_vm._v(" 加征税率1 ")]
                            ),
                            _vm._v(
                              " " + _vm._s(`${row.scope.addRate1}%`) + " "
                            ),
                          ]),
                          _c("p", [
                            _c(
                              "span",
                              {
                                staticClass: "pickUpType",
                                class: `pickUpType1`,
                              },
                              [_vm._v(" 加征税率2 ")]
                            ),
                            _vm._v(
                              " " + _vm._s(`${row.scope.addRate2}%`) + " "
                            ),
                          ]),
                          _c("p", [
                            _c(
                              "span",
                              {
                                staticClass: "pickUpType",
                                class: `pickUpType2`,
                              },
                              [_vm._v(" 加征税率3 ")]
                            ),
                            _vm._v(
                              " " + _vm._s(`${row.scope.addRate3}%`) + " "
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "opt",
                      fn: function (row) {
                        return [
                          _c(
                            "el-popover",
                            {
                              ref: `popover${row.scope.id}`,
                              attrs: {
                                placement: "bottom-start",
                                "popper-class": "pop-table-opt",
                                width: "114",
                                trigger: "click",
                              },
                            },
                            [
                              _c("div", { staticClass: "table-opt" }, [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permissson",
                                            rawName: "v-permissson",
                                            value: "update",
                                            expression: "'update'",
                                          },
                                        ],
                                        staticClass: "opt-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleEdit(row.scope)
                                          },
                                        },
                                      },
                                      [_vm._v("修改")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permissson",
                                            rawName: "v-permissson",
                                            value: "delete",
                                            expression: "'delete'",
                                          },
                                        ],
                                        staticClass: "opt-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleDelete(row.scope)
                                          },
                                        },
                                      },
                                      [_vm._v("删除")]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c("img", {
                                attrs: {
                                  slot: "reference",
                                  src: require("@/assets/images/table/opt.png"),
                                },
                                slot: "reference",
                              }),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1444085432
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c("AddClearanceConsultationDialog", {
        attrs: { dialogVisible: _vm.dialogVisible, editData: _vm.editData },
        on: { cancel: _vm.cancel, ok: _vm.ok },
      }),
      _c("FileListDialog", {
        attrs: { dialogVisible: _vm.dialogVisible2, rowData: _vm.editData },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible2 = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }